

// import { Injectable } from "@angular/core";
// import { io, Socket } from "socket.io-client";
// import { Observable } from "rxjs";
// import { BehaviorSubject } from "rxjs";

// @Injectable({
//   providedIn: "root",
// })
// export class SocketService {
//     private socket: Socket;

//   public socketId: string = "";
//   public newMessage$ = new BehaviorSubject<any>(null); // Store received messages

//   constructor() {
//     this.socket = io("https://chat.routespro.com", {
//       transports: ['websocket'], // Ensures WebSocket connection
//       reconnection: true, // Auto-reconnect enabled
//       reconnectionAttempts: Infinity, // Try reconnecting indefinitely
//       reconnectionDelay: 3000, // Wait 3s before reconnecting
//     });

//     // Get the assigned socket ID
//     this.socket.on("connect", () => {
//       this.socketId = this.socket.id;
//       console.log("Connected with Socket ID:", this.socketId);
//     });
//   }

//   getSocketId(): string {
//     return this.socketId;
//   }

//   joinRoom(roomId) {
//     console.log("Joining Room:", roomId);
//     this.socket.emit("joinRoom",{ room: roomId});
//   }


//   listenForMessages(): Observable<any> {
//     return new Observable((observer) => {
//       this.socket.on("receiveMessage", (messageData) => {
//         observer.next(messageData);
//       });
//     });
//   }

//   sendMessage(message: any) {    
//     this.socket.emit("sendMessage", message );
//   }
// }



import { Injectable } from "@angular/core";
import { io, Socket } from "socket.io-client";
import { Observable, BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SocketService {
  private socket: Socket;
  public socketId: string = "";

  public newMessage$ = new BehaviorSubject<any>(null); // received message
  public isConnected$ = new BehaviorSubject<boolean>(false); // connection status

  private currentRoomId: string | null = null; // store last joined room

  constructor() {
    this.connectSocket();
  }

  private connectSocket() {
    this.socket = io("https://chat.routespro.com", {
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 3000,
    });

    this.socket.on("connect", () => {
      this.socketId = this.socket.id;
      this.isConnected$.next(true);
      console.log("🟢 Connected with Socket ID:", this.socketId);

      // Re-join room if previously joined
      if (this.currentRoomId) {
        this.joinRoom(this.currentRoomId);
      }
    });

    this.socket.on("disconnect", (reason) => {
      this.isConnected$.next(false);
      console.log("🔴 Socket disconnected:", reason);
    });

    this.socket.on("reconnect_attempt", (attempt) => {
      console.log("🔁 Reconnecting... attempt:", attempt);
    });

    this.socket.on("reconnect", (attemptNumber) => {
      console.log("✅ Reconnected after", attemptNumber, "attempts");
    });
  }

  getSocketId(): string {
    return this.socketId;
  }

  joinRoom(roomId: string) {
    this.currentRoomId = roomId;
    console.log("Joining Room:", roomId);
    this.socket.emit("joinRoom", { room: roomId });
  }

  listenForMessages(): Observable<any> {
    return new Observable((observer) => {
      this.socket.on("receiveMessage", (messageData) => {
        observer.next(messageData);
      });
    });
  }

  sendMessage(message: any) {
    this.socket.emit("sendMessage", message);
  }
}